import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, ResponsiveContainer } from 'recharts';

export const ProgressRadar = ({ data, testid = 'progress-radar' }) => (
  <div data-testid={testid} className="w-full h-72">
    <ResponsiveContainer width="100%" height="100%">
      <RadarChart data={data} outerRadius="60%" margin={{ top: 10, right: 30, bottom: 10, left: 30 }}>
        <PolarGrid stroke="#26507A" />
        <PolarAngleAxis dataKey="axis" tick={{ fill: '#F5EDD8', fontSize: 11, fontWeight: 700, fontFamily: 'Nunito' }} />
        <PolarRadiusAxis domain={[0, 100]} tick={false} axisLine={false} />
        <Radar dataKey="value" stroke="#E8C566" fill="#D9AE4A" fillOpacity={0.4} strokeWidth={2.5} isAnimationActive />
      </RadarChart>
    </ResponsiveContainer>
  </div>
);
